import Vue from "vue";

import "@/styles/index.scss"; // global css
import Element from "element-ui";
import esLang from "element-ui/lib/locale/lang/es";
import Cookies from "js-cookie";
import "normalize.css/normalize.css"; // a modern alternative to CSS resets
import "./styles/element-variables.scss";
/* Vue Font Awesome */
import "@fortawesome/fontawesome-free/css/all.css"; // Ensure you are using css-loader
import { v4 as uuid } from "uuid";
import "material-icons/iconfont/material-icons.css";
import App from "./App";
import router from "./router";
import store from "./store";

import "./icons"; // icon
import "./permission"; // permission control
// import "./utils/error-log"; // error log
import { setCustomAttribute } from "@/api/logging";
import Vuelidate from "vuelidate";
import * as filters from "./filters"; // global filters

import "./utils/newrelic"; // New Relic initialization
import "./guards/newrelic"; // New Relic guard

Vue.prototype.toJSON = () => {};

/*
VueJs Currency Input
 */
import VueCurrencyInput from "vue-currency-input";

/*
 * Leaflet
 */
import "./utils/leaflet";

/*
 * Inicialización del paquete vue-form-wizard
 */
import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
/**
 * Vue Virtual Scroller
 */
import VueVirtualScroller from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

/**
 * Vue ScrollTo
 */
import VueScrollTo from "vue-scrollto";
/**
 * VueShortkey
 */
import VueShortkey from "vue-shortkey";
/**
 * VueSchedule
 */
import { EventBusPlugin } from "@/events";
import Schedule from "vue-schedule";
import agent from "./utils/newrelic";

Vue.use(EventBusPlugin);
Vue.use(Vuelidate);

Vue.config.errorHandler = (err, vm, info) => {
  agent.noticeError(err, {
    vm,
    info,
    url: window.location.href,
  });
  console.error(err);
  throw err;
};

Vue.use(Element, {
  size: Cookies.get("size") || "small", // set element-ui default size
  // i18n: (key, value) => i18n.t(key, value),
  locale: esLang,
});

/*
 * Vue i18n
 */
// import VueI18n from "vue-i18n";
// Vue.use(VueI18n);
// import i18n from "@/lang";
Vue.use(VueCurrencyInput, {
  globalOptions: {
    locale: "es",
  },
});

Vue.use(VueFormWizard);

// register global utility filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Vue.use(VueVirtualScroller);

Vue.use(VueScrollTo);

Vue.use(VueShortkey);

Vue.use(Schedule);

// Vue.config.productionTip = false;

const instance = new Vue({
  el: "#app",
  router,
  store,
  // i18n,
  render: (h) => h(App),
});

const startTime = new Date().getTime();

agent.setCustomAttribute("originDomain", window.location.hostname);
setCustomAttribute("originDomain", window.location.hostname);

if (!window.localStorage.getItem("computer-identifier")) {
  window.localStorage.setItem("computer-identifier", uuid());
}

const computerId = window.localStorage.getItem("computer-identifier");
agent.setCustomAttribute("computerId", computerId);
setCustomAttribute("computerId", computerId);

if (window.memoryInterval) {
  clearInterval(window.memoryInterval);
}
window.memoryInterval = setInterval(async () => {
  const timeSinceStart = new Date().getTime() - startTime;
  agent.setCustomAttribute("timeSinceStart", timeSinceStart);

  if (window.performance?.memory) {
    agent.addPageAction("BrowserMemory", {
      memoryHeap: window.performance?.memory?.totalJSHeapSize,
      memoryUsed: window.performance?.memory?.usedJSHeapSize,
    });
  }
  agent.addPageAction("ConnectionSpeed", {
    downlink: navigator.connection?.downlink,
  });
  agent.addPageAction("Storage", {
    indexdb: (await navigator.storage?.estimate())?.usage,
  });
}, 90000);

export default instance;
